export {default as ZoomSlide} from "./ZoomSlide";
export {default as ThumbsSlide} from "./ThumbsSlide";
export {default as ProductDetailSlide} from "./ProductDetailSlide";
export {default as RecommendationSlide} from "./RecommendationSlide";
export {default as EventSlide} from "./EventSlide";
export {default as GuideSlide} from "./GuideSlide";
